module.exports = __webpack_public_path__ + "img/foam_xl.703ef364.png";